import { render } from "./GetTipsStartNew.vue?vue&type=template&id=3bec0398"
import script from "./GetTipsStartNew.vue?vue&type=script&lang=js"
export * from "./GetTipsStartNew.vue?vue&type=script&lang=js"

import "./GetTipsStartNew.vue?vue&type=style&index=0&id=3bec0398&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__